import PropTypes from "prop-types";
import LazyProductHeroContainer from "../LazyProductHeroContainer";
import useMatchMedia from "../useMatchMedia";
import media from "../../../../styles/customMedia.json";
import { useInView } from "react-intersection-observer";
const {
  customMedia: { ["--medium-viewport"]: mediumViewport }
} = media;

const LazyProductHero = ({ render, className, children }) => {
  const isMediumViewportOrGreater = useMatchMedia(mediumViewport);
  const { ref, inView } = useInView({
    rootMargin: isMediumViewportOrGreater ? "510px" : "410px",
    triggerOnce: true,
    skip: isMediumViewportOrGreater === null
  });

  return (
    <LazyProductHeroContainer
      ref={ref}
      doLoad={inView}
      className={className}
      render={render}
    >
      {children}
    </LazyProductHeroContainer>
  );
};

LazyProductHero.propTypes = {
  render: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default LazyProductHero;
